<ng-template #columnDefinitions>
  <colgroup>
    @for (headerDirective of headerDirectives(); track headerDirective.appTableCellHeaderKey()) {
      <col [style.width]="headerDirective.appTableCellHeaderCellWidth() ?? null" />
    }
  </colgroup>
</ng-template>

<ng-template #header>
  <thead>
    <tr>
      @for (headerDirective of headerDirectives(); track headerDirective.appTableCellHeaderKey(); let first = $first; let last = $last) {
        <th
          [ngClass]="{
            'sticky top-0 z-10 bg-background-container-secondary': stickyHeaders(),
            'rounded-l-radius-primary': stickyHeaders() && first,
            'rounded-r-radius-primary': stickyHeaders() && last,
          }"
        >
          <div
            class="grow flex flex-col justify-center min-h-[37px] text-sm font-medium text-left text-foreground-primary-60"
            [ngClass]="{
              'pl-[18px]': first,
              'pr-[18px]': last,
            }"
          >
            <ng-container *ngTemplateOutlet="headerDirective.templateRef"></ng-container>
          </div>
        </th>
      }
    </tr>
  </thead>
</ng-template>

<ng-template #row let-dataRow let-index="index">
  <tr (pointerenter)="rowHover.emit(dataRow)" (pointerleave)="rowUnhover.emit()">
    @let routerLinkData = rowRouterLinkFn()?.(dataRow);
    @for (cellDirective of cellDirectives(); track cellDirective.appTableCellKey(); let first = $first; let last = $last) {
      @let rowSpan = cellRowSpanFn()?.(dataRow, cellDirective.appTableCellKey());
      @if (rowSpan !== 0) {
        <td
          class="h-[49px] align-middle"
          [attr.rowspan]="rowSpan ?? null"
          [ngClass]="[
            rowClassFn()?.(dataRow) ?? 'bg-background-fixed',
            first ? 'rounded-tl-radius-container rounded-bl-radius-container' : '',
            last ? 'rounded-tr-radius-container rounded-br-radius-container' : '',
          ]"
        >
          @if (routerLinkData) {
            <a
              [routerLink]="routerLinkData.routerLink"
              [queryParams]="routerLinkData.queryParams"
              [state]="routerLinkData.state"
              class="flex flex-col justify-center h-full"
            >
              <ng-container *ngTemplateOutlet="cell"></ng-container>
            </a>
          } @else {
            <ng-container *ngTemplateOutlet="cell"></ng-container>
          }

          <ng-template #cell>
            <div class="flex flex-col justify-center text-sm font-medium" [ngClass]="[first ? 'pl-[18px]' : '', last ? 'pr-[18px]' : '']">
              <ng-container *ngTemplateOutlet="cellDirective.templateRef; context: { $implicit: dataRow, index }"></ng-container>
            </div>
          </ng-template>
        </td>
      }
    }
  </tr>
</ng-template>

<ng-template #footer>
  @if (footerDirectives().length > 0) {
    @let footerDirectivesByKeyValue = footerDirectivesByKey();
    <tfoot>
      <tr>
        @for (cellDirective of cellDirectives(); track cellDirective.appTableCellKey(); let first = $first; let last = $last) {
          @let footerDirective = footerDirectivesByKeyValue.get(cellDirective.appTableCellKey());
          <th>
            <div
              class="grow flex flex-col justify-center h-[37px] text-sm font-medium"
              [ngClass]="{
                'pl-[18px]': first,
                'pr-[18px]': last,
              }"
            >
              @if (footerDirective) {
                <ng-container *ngTemplateOutlet="footerDirective.templateRef"></ng-container>
              }
            </div>
          </th>
        }
      </tr>
    </tfoot>
  }
</ng-template>

@if (virtualScroll()) {
  <table class="w-full table-fixed border-separate border-spacing-y-1 -my-1">
    <ng-container *ngTemplateOutlet="columnDefinitions"></ng-container>
    <ng-container *ngTemplateOutlet="header"></ng-container>
  </table>
  <cdk-virtual-scroll-viewport [itemSize]="virtualScrollItemSize()" class="grow min-h-0 overflow-x-hidden overflow-y-auto">
    <table class="w-full table-fixed border-separate border-spacing-y-1 -my-1">
      <ng-container *ngTemplateOutlet="columnDefinitions"></ng-container>
      <tbody>
        <ng-container *cdkVirtualFor="let dataRow of dataSource(); let index = index; trackBy: trackByKey">
          <ng-container *ngTemplateOutlet="row; context: { $implicit: dataRow, index }"></ng-container>
        </ng-container>
      </tbody>
    </table>
  </cdk-virtual-scroll-viewport>
  <table class="w-full table-fixed border-separate border-spacing-y-1 -my-1">
    <ng-container *ngTemplateOutlet="columnDefinitions"></ng-container>
    <ng-container *ngTemplateOutlet="footer"></ng-container>
  </table>
} @else {
  <table class="grow border-separate border-spacing-y-1 -my-1">
    <ng-container *ngTemplateOutlet="columnDefinitions"></ng-container>
    <ng-container *ngTemplateOutlet="header"></ng-container>
    <tbody>
      @for (dataRow of dataSource(); track dataRow[keyProperty()]; let index = $index) {
        <ng-container *ngTemplateOutlet="row; context: { $implicit: dataRow, index }"></ng-container>
      }
    </tbody>
    <ng-container *ngTemplateOutlet="footer"></ng-container>
  </table>
}
